module.exports = __webpack_public_path__ + "static/media/angel.9dfa72bb.jpeg";